import { createSelector } from '@ngrx/store';
import { bannedProvisioningIpRegisterSelector } from './banned-provisioning-ip-register.reducer';

export const selectFilters = createSelector(bannedProvisioningIpRegisterSelector, (state) => {
   return state.filters;
});
